import { NotificationTypes, SafeAny } from '@/common/types';
import { axiosInstance } from '@/common/utils';
import { SignalOverflow, UpdateUserPayload, UserResponse } from '@/modules/epoch/types';
import { presetsToApi } from '../lane-height.mapper';

export const updatePresetSettings = async (
  { rootState, state, commit, dispatch }: SafeAny,
  updateSettings: NonNullable<any>
) => {
  const url = `${rootState.env?.requestUrl.events}/user`;
  const { selectedPresetId, name, isSelectedPresetChange, isNewPreset } = updateSettings;

  state.settings.requestSequence = (state.settings.requestSequence ?? 0) + 1;
  const dispatchSequence = state.settings.requestSequence;

  state.settings = {
    ...state.settings,
    isLoading: true,
    error: undefined
  };

  let payload: UpdateUserPayload;

  if (isSelectedPresetChange) {
    payload = {
      selectedPresetId
    };
  } else {
    const presets = [...state.settings.presets];
    const index = isNewPreset ? -1 : presets.findIndex((p) => p.name === name);

    const basePreset = index >= 0 ? presets[index] : { ...state.settings.presets[0] };
    const presetId = isNewPreset ? Date.now() : selectedPresetId;

    const presetToSave = {
      ...basePreset,
      id: presetId,
      name,
      signalsList: state.settings.signalsList,
      hypnogramFullNightSignals: state.settings.hypnogramFullNightSignals,
      signalOverflow: state.settings.signalOverflow ?? SignalOverflow.None,
      band: state.settings.band,
      notch: state.settings.notch,
      viewMode: state.settings.viewMode,
      dualTimeBase: state.settings.dualTimeBase,
      artifactColor: state.settings.artifactColor,
      shortcutKeys: state.settings.shortcutKeys
    };

    if (index >= 0) {
      presets[index] = presetToSave;
    } else {
      presets.push(presetToSave);
    }

    payload = {
      selectedPresetId: presetId,
      presets: presetsToApi(presets)
    };
  }

  try {
    await axiosInstance
      .patch<UserResponse>(url, payload)
      .then((response) => {
        if (state.settings.requestSequence === dispatchSequence) {
          commit('setSettingsFromAPI', response.data);
        }
      })
      .catch(() => {
        dispatch('epoch/getPresetSettings');
      });
  } catch (error: SafeAny) {
    Object.assign(state.settings, {
      isLoading: false,
      presets: [],
      error
    });

    commit(
      'addNotification',
      {
        i18nTitle: 'fetchError',
        type: NotificationTypes.Error,
        i18nDescription: error.message
      },
      { root: true }
    );
  }
};
